import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Consultations from "@/pages/Consultations";
import Appointments from "@/pages/Appointments";
import Payments from "@/pages/Payments";
import Products from "@/pages/Products";
import Leads from "@/pages/Leads";
import Followups from "@/pages/Followups";
import Vastu from "@/pages/Vastu";
import Numerology from "@/pages/Numerology";
import Kundli from "@/pages/Kundli";
import KundliMilan from "@/pages/KundliMilan";
import KundliMilanHistory from "@/pages/KundliMilanHistory";
import SavedKundlis from "@/pages/SavedKundlis";
import Reports from "@/pages/Reports";
import AIAssistant from "@/pages/AIAssistant";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
        <div className="text-sm text-slate-500">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Layout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:id" element={<ClientDetail />} />
        <Route path="consultations" element={<Consultations />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="payments" element={<Payments />} />
        <Route path="products" element={<Products />} />
        <Route path="leads" element={<Leads />} />
        <Route path="followups" element={<Followups />} />
        <Route path="vastu" element={<Vastu />} />
        <Route path="numerology" element={<Numerology />} />
        <Route path="kundli" element={<Kundli />} />
        <Route path="kundli/saved" element={<SavedKundlis />} />
        <Route path="kundli-milan" element={<KundliMilan />} />
        <Route path="kundli-milan/history" element={<KundliMilanHistory />} />
        <Route path="reports" element={<Reports />} />
        <Route path="ai" element={<AIAssistant />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}
